import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box } from "@mui/material";

// ----------------------------------------------------------------------

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  // minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(2, 0),
}));

// ----------------------------------------------------------------------

const Page401 = () => {
  return (
    <>
      <Helmet>
        <title> 401 Unauthorized </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: "center", alignItems: "center" }}>
          <Typography variant="h3" paragraph>
            Unauthorized!
          </Typography>

          <Typography sx={{ color: "text.secondary" }}>
            Sorry, you are not authorized to access this page. <br></br> Please
            contact the support team.
          </Typography>

          <Box
            component="img"
            src="/images/401.png"
            sx={{ height: 260, mx: "auto", my: { xs: 5, sm: 10 } }}
          />

          <Button
            to="/login"
            size="large"
            variant="contained"
            component={RouterLink}
          >
            Go to Login
          </Button>
        </StyledContent>
      </Container>
    </>
  );
};

export default Page401;
